const testimonials = [
  {
    stars: 5,
    text: '"FiberLink has transformed our business. The speeds are incredible and support is always there when we need them. Highly recommended!"',
    initials: 'MU',
    name: 'Musa',
    role: 'Tech Startup CEO',
  },
  {
    stars: 5,
    text: '"Best ISP I\'ve ever had. No more buffering during video calls. The fiber connection is rock solid and the installation was seamless."',
    initials: 'AK',
    name: 'Ahmed khan',
    role: 'Remote Developer',
  },
  {
    stars: 5,
    text: '"Worth every penny! Our whole family can stream, game, and work simultaneously without any lag. Customer service is top-notch!"',
    initials: 'M',
    name: 'Muhammad',
    role: 'Family of 5',
  },
  {
    stars: 5,
    text: '"Switched from our old provider and the difference is night and day. FiberLink delivers exactly what they promise. Couldn\'t be happier!"',
    initials: 'HK',
    name: 'Hamza khan',
    role: 'Content Creator',
  },
];

export const trustBadges = [
  { emoji: '🏢', name: 'TechCorp' },
  { emoji: '🚀', name: 'StartupHub' },
  { emoji: '💼', name: 'Enterprise Plus' },
  { emoji: '🎮', name: 'GameStream' },
  { emoji: '📱', name: 'CloudNet' },
];

export default testimonials;
